import { ItemizedResult } from "@/types/diagnostic";

export type ItemizedQuestion = {
  type: Type;
  questions: Question[];
};

type Question = {
  title: string;
  answers: Answer[];
};

type Answer = {
  title: string;
};

type Type =
  | "DX基礎力"
  | "働き方のDX"
  | "効率化するDX"
  | "魅力を伝えるDX"
  | "会計のDX";

export const ItemizedQuestions: ItemizedQuestion[] = [
  {
    type: "DX基礎力",
    questions: [
      {
        title: "お客様からのお問い合わせや応対の履歴を記録し、蓄積している",
        answers: [
          {
            title: "徹底できている",
          },
          {
            title: "できている",
          },
          {
            title: "どちらともいえない",
          },
          {
            title: "できていない",
          },
          {
            title: "全くできていない",
          },
        ],
      },
      {
        title:
          "どういう時に何をすべきか、いつも行う定型業務の手順や基準は明確になっている",
        answers: [
          {
            title: "常に明確にできている",
          },
          {
            title: "一部を除いて明確にできている",
          },
          {
            title: "どちらともいえない",
          },
          {
            title: "一部のみ明確にできている",
          },
          {
            title: "明確にできていない",
          },
        ],
      },
      {
        title: "手書き・手計算の仕事は極力減らしている",
        answers: [
          {
            title: "徹底できている",
          },
          {
            title: "できている",
          },
          {
            title: "どちらともいえない",
          },
          {
            title: "できていない",
          },
          {
            title: "全くできていない",
          },
        ],
      },
      {
        title:
          "他の中小ビジネスのデジタルツール活用の取り組みをキャッチアップしている",
        answers: [
          {
            title: "実践までできている",
          },
          {
            title: "できている",
          },
          {
            title: "どちらともいえない",
          },
          {
            title: "できていない",
          },
          {
            title: "全くできていない",
          },
        ],
      },
      {
        title: "社員や部署の予定をデジタルで管理できている",
        answers: [
          {
            title: "常にアクセスできる状態にある",
          },
          {
            title: "ツールは入れているが管理はできていない",
          },
          {
            title: "どちらともいえない",
          },
          {
            title: "できていない",
          },
          {
            title: "全くできていない",
          },
        ],
      },
    ],
  },
  {
    type: "働き方のDX",
    questions: [
      {
        title:
          "社内・社外の場所を問わず、どこからでも、いつでも必要な情報にアクセスできる",
        answers: [
          {
            title: "アクセスできる",
          },
          {
            title: "社内からのみアクセスできる",
          },
          {
            title: "どちらともいえない",
          },
          {
            title: "できない",
          },
          {
            title: "把握できていない",
          },
        ],
      },
      {
        title: "会社の情報は決められた場所に格納され、一元管理されている",
        answers: [
          {
            title: "徹底できている",
          },
          {
            title: "できている",
          },
          {
            title: "どちらともいえない",
          },
          {
            title: "できていない",
          },
          {
            title: "全くできていない",
          },
        ],
      },
      {
        title:
          "デジタルへの慣れや習慣が一人一人異なる現実を踏まえてデジタル化に挑戦している",
        answers: [
          {
            title: "挑戦できている",
          },
          {
            title: "できている",
          },
          {
            title: "どちらともいえない",
          },
          {
            title: "できていない",
          },
          {
            title: "全くできていない",
          },
        ],
      },
      {
        title: "業務の流れを見直して、情報の二重入力を減らす工夫をしている",
        answers: [
          {
            title: "実践までできている",
          },
          {
            title: "見直しまでできている",
          },
          {
            title: "どちらともいえない",
          },
          {
            title: "できていない",
          },
          {
            title: "全くできていない",
          },
        ],
      },
      {
        title:
          "社員の業務がマニュアル化されている（属人化・ブラックボックス化されていない状態にある）",
        answers: [
          {
            title: "マニュアル化されている",
          },
          {
            title: "業務の把握はできている",
          },
          {
            title: "どちらともいえない",
          },
          {
            title: "できていない",
          },
          {
            title: "業務の把握が感できていない",
          },
        ],
      },
    ],
  },
  {
    type: "効率化するDX",
    questions: [
      {
        title: "業務の省力化とスピードアップのためのシステムを整備している",
        answers: [
          {
            title: "整備している",
          },
          {
            title: "整備途中",
          },
          {
            title: "どちらともいえない",
          },
          {
            title: "できていない",
          },
          {
            title: "全くできていない",
          },
        ],
      },
      {
        title:
          "重要情報（指標）の最新状況と推移をモニタリングできる仕組みがある",
        answers: [
          {
            title: "運用までできている",
          },
          {
            title: "仕組みはある",
          },
          {
            title: "どちらともいえない",
          },
          {
            title: "できていない",
          },
          {
            title: "全くできていない",
          },
        ],
      },
      {
        title:
          "業務のスピードと品質を計測し、業務手順やリソース配置の見直しに役立てている",
        answers: [
          {
            title: "徹底できている",
          },
          {
            title: "できている",
          },
          {
            title: "どちらともいえない",
          },
          {
            title: "できていない",
          },
          {
            title: "全くできていない",
          },
        ],
      },
      {
        title:
          "業務のボトルネックを見つけ、それを改善する仕組みが会社全体で構築できている",
        answers: [
          {
            title: "構築できている",
          },
          {
            title: "構築途中",
          },
          {
            title: "どちらともいえない",
          },
          {
            title: "できていない",
          },
          {
            title: "全くできていない",
          },
        ],
      },
      {
        title:
          "デジタルツールを活用してみたい、という現場からの提案を形にできている",
        answers: [
          {
            title: "実践までできている",
          },
          {
            title: "検討はしている",
          },
          {
            title: "どちらともいえない",
          },
          {
            title: "できていない",
          },
          {
            title: "全くできていない",
          },
        ],
      },
    ],
  },
  {
    type: "魅力を伝えるDX",
    questions: [
      {
        title:
          "経営理念に基づき、自社の魅力を最も的確に表現するメッセージを定め、徹底している",
        answers: [
          {
            title: "徹底できている",
          },
          {
            title: "できている",
          },
          {
            title: "どちらともいえない",
          },
          {
            title: "できていない",
          },
          {
            title: "全くできていない",
          },
        ],
      },
      {
        title:
          "営業資料やチラシ、ホームページなど、TPOにあわせた魅力伝達手段を整えている",
        answers: [
          {
            title: "発信までできている",
          },
          {
            title: "整えている",
          },
          {
            title: "どちらともいえない",
          },
          {
            title: "できていない",
          },
          {
            title: "全くできていない",
          },
        ],
      },
      {
        title:
          "すべてのスタッフが、社外の方とお会いする際に、自社の魅力を伝達する役割を自分も担っていることを認識している",
        answers: [
          {
            title: "実践までできている",
          },
          {
            title: "浸透はしている",
          },
          {
            title: "どちらともいえない",
          },
          {
            title: "できていない",
          },
          {
            title: "全くできていない",
          },
        ],
      },
      {
        title:
          "SNSやHP、ブログ等を通じて定期的に情報発信を行う仕組みを整えている",
        answers: [
          {
            title: "発信までできている",
          },
          {
            title: "整えている",
          },
          {
            title: "どちらともいえない",
          },
          {
            title: "できていない",
          },
          {
            title: "全くできていない",
          },
        ],
      },
      {
        title:
          "自社の発信の成果を計測・検証し、より効果的な宣伝活動につなげている",
        answers: [
          {
            title: "計測・検証のサイクルを回せている",
          },
          {
            title: "計測はできている",
          },
          {
            title: "どちらともいえない",
          },
          {
            title: "できていない",
          },
          {
            title: "全くできていない",
          },
        ],
      },
    ],
  },
  {
    type: "会計のDX",
    questions: [
      {
        title:
          "オンラインでのデータの授受や取引で発生する帳票の電子化を進めている",
        answers: [
          {
            title: "実践までできている",
          },
          {
            title: "進めている",
          },
          {
            title: "どちらともいえない",
          },
          {
            title: "できていない",
          },
          {
            title: "全くできていない",
          },
        ],
      },
      {
        title:
          "給与振込や経費精算等、会社のお金の流れはオンラインバンクやデジタルツールを通じてリアルタイムで見える化できている",
        answers: [
          {
            title: "すべて見える化できている",
          },
          {
            title: "一部見える化できている",
          },
          {
            title: "どちらともいえない",
          },
          {
            title: "できていない",
          },
          {
            title: "全くできていない",
          },
        ],
      },
      {
        title: "現金でのやりとりを極力減らしている",
        answers: [
          {
            title: "すべて電子化されている",
          },
          {
            title: "減らしている",
          },
          {
            title: "どちらともいえない",
          },
          {
            title: "できていない",
          },
          {
            title: "全くできていない",
          },
        ],
      },
      {
        title:
          "バックオフィス業務のIT対応やデジタル化に関しての中小企業の取り組みをキャッチアップしている",
        answers: [
          {
            title: "実践までできている",
          },
          {
            title: "できている",
          },
          {
            title: "どちらともいえない",
          },
          {
            title: "できていない",
          },
          {
            title: "全くできていない",
          },
        ],
      },
      {
        title: "会計の〆日から遅滞なく決算状況が確認できる仕組みが整っている",
        answers: [
          {
            title: "整っている",
          },
          {
            title: "少しの遅延はあるが、整っている",
          },
          {
            title: "どちらともいえない",
          },
          {
            title: "整っていない",
          },
          {
            title: "全く整っていない",
          },
        ],
      },
    ],
  },
];

export const ItemizedResults: ItemizedResult[] = [
  {
    heading: "DX基礎力",
    evaluations: [
      {
        description:
          "現場のスタッフが、迷わず、間違わず仕事をすすめるための計画を立てる必要があります。現場の業務を滑らかに進めるには何が必要か、まず洗い出してみましょう。",
      },
      {
        description:
          "DX推進のためには、職場環境の整備が不可欠です。デジタルツールを活用することで、記録が習慣化し、改善の指標を得られるようになります。",
      },
      {
        description:
          "デジタル経営の基盤を作るにはあと一歩。社内連絡ツールの導入やクラウド内でのファイル整理など、チェック表をつくり1つずつ改善しましょう。",
      },
      {
        description:
          "やり戻しや手戻りを減らし、現場の業務を滑らかに進めるにはもうひと工夫できそうです。職場の暗黙知を文書や動画としてに残していくこともおすすめですよ。",
      },
      {
        description:
          "素晴らしいですね。デジタル経営の基盤となる職場の環境づくりができているといえるでしょう。",
      },
    ],
    recommend: [
      {
        datail: [{ url: "", text: "" }],
      },
      {
        datail: [{ url: "", text: "" }],
      },
      {
        datail: [{ url: "", text: "" }],
      },
      {
        datail: [{ url: "", text: "" }],
      },
      {
        datail: [{ url: "", text: "" }],
      },
    ],
  },
  {
    heading: "働き方のDX",
    evaluations: [
      {
        description:
          "働き方に大きく改善の余地がありそうです。まずはインターネット上で報告連絡相談を徹底するところから始めましょう。",
      },
      {
        description:
          "ヒト・モノ・カネに加えて、情報の価値が高まっている時代です。整理し、活用するクセを会社全体で身につけましょう。",
      },
      {
        description:
          "クラウドの活用や無線LANの導入、情報端末の整備、情報共有ツールの導入など、チェック表をつくり1つずつ改善しましょう。",
      },
      {
        description:
          "情報を扱う際の非効率を減らす工夫ができるとよさそうです。ツールの見直しやルールづくりを検討・実施していきましょう。",
      },
      {
        description:
          "社内にある情報は美しく整理され、利用されているようです。デジタル経営の基礎は盤石ですね。",
      },
    ],
    recommend: [
      {
        datail: [{ url: "", text: "" }],
      },
      {
        datail: [{ url: "", text: "" }],
      },
      {
        datail: [{ url: "", text: "" }],
      },
      {
        datail: [{ url: "", text: "" }],
      },
      {
        datail: [{ url: "", text: "" }],
      },
    ],
  },
  {
    heading: "効率化するDX",
    evaluations: [
      {
        description:
          "仕事の省力化と自動化の余地がまだまだ大きそうです。管理水準を高める取り組みを開始しましょう。",
      },
      {
        description:
          "より早く、より少ない人数で仕事を終わらせるにはデジタルツールの活用も必要です。まずは定型的な業務のスピードと品質を計測するようにしてみましょう。",
      },
      {
        description:
          "業務管理のレベルをより一層高水準にするために、業務管理の仕組みを見直してみてはいかがでしょうか？全体最適の観点からシステムの導入も検討しましょう。",
      },
      {
        description:
          "業務改善の習慣を当たり前にすべく、見える化・数値化できていないところを再度確認してみましょう。",
      },
      {
        description:
          "業務管理が極めて高水準で行われていますね。生み出した余力を品質やサービスレベルのより一層の向上に使いましょう。",
      },
    ],
    recommend: [
      {
        datail: [{ url: "", text: "" }],
      },
      {
        datail: [{ url: "", text: "" }],
      },
      {
        datail: [{ url: "", text: "" }],
      },
      {
        datail: [{ url: "", text: "" }],
      },
      {
        datail: [{ url: "", text: "" }],
      },
    ],
  },
  {
    heading: "魅力を伝えるDX",
    evaluations: [
      {
        description:
          "インターネットで発信をしないことで、売上だけでなく採用でも機会ロスをしている可能性が高いです。まずはアウトプットをする習慣を身につけましょう。",
      },
      {
        description:
          "社外の声に耳を傾け、自社の理念と魅力を伝えられる素材を整えましょう。",
      },
      {
        description:
          "魅力を伝達する重要性は理解している様子。HPや営業資料をブラッシュアップして、応援団・ファンを増やしていきましょう。",
      },
      {
        description:
          "発信の質を高めるためには量を出す必要があります。アイデアを形にするスピードを上げて、検証と実践を繰り返しましょう。",
      },
      {
        description:
          "社外に魅力を伝える達人です。こまやかなコミュニケーションを今後も継続していきましょう。",
      },
    ],
    recommend: [
      {
        datail: [{ url: "", text: "" }],
      },
      {
        datail: [{ url: "", text: "" }],
      },
      {
        datail: [{ url: "", text: "" }],
      },
      {
        datail: [{ url: "", text: "" }],
      },
      {
        datail: [{ url: "", text: "" }],
      },
    ],
  },
  {
    heading: "会計のDX",
    evaluations: [
      {
        description:
          "会計ソフトやクラウドツールを活用することで、より一層仕事の効率化が計れそうです。バックオフィスの業務全体を見直してみましょう。",
      },
      {
        description:
          "お金の出入りが一部ブラックボックスになっているようです。決算の〆に必要以上の時間がかからないよう、デジタルツール導入で手間を省きましょう。",
      },
      {
        description:
          "会計のDXの必要性は理解しているものの、実践は道半ばのようですね。セミナー等に参加し、相談できるパートナーを見つけてみてはいかがでしょうか。",
      },
      {
        description:
          "管理体制を強化することで予実管理が可能となります。前月の反省をすぐに経営判断に活かせるよう、お金の動きをリアルタイムで把握しましょう。",
      },
      {
        description:
          "バックオフィス業務が効率的に仕組み化されているといえます。より一層顧客価値の向上に注力していきましょう。",
      },
    ],
    recommend: [
      {
        datail: [{ url: "", text: "" }],
      },
      {
        datail: [{ url: "", text: "" }],
      },
      {
        datail: [{ url: "", text: "" }],
      },
      {
        datail: [{ url: "", text: "" }],
      },
      {
        datail: [{ url: "", text: "" }],
      },
    ],
  },
];
